import type { Border, Cell, ITableLayerProps } from '@/version-types';

export const emptyBorder: Border = {
    color: '#00000000',
    style: 'line-0',
    width: 0,
};

/** 获取当前网格所属的单元格 */
export const getCellByIndexes = ({
    tableLayerData,
    indexes,
}: {
    tableLayerData: ITableLayerProps;
    indexes: { rowIndex: number; colIndex: number };
}): Cell | null =>
    tableLayerData.cells.flat().find((cell) => {
        return (
            cell &&
            cell.hIndex <= indexes.colIndex &&
            indexes.colIndex < cell.hIndex + cell.colSpan &&
            cell.vIndex <= indexes.rowIndex &&
            indexes.rowIndex < cell.vIndex + cell.rowSpan
        );
    }) ?? null;

export const isEqualBorder = (a: Border | null | undefined, b: Border | null | undefined): boolean => {
    const aWidth = a?.width ?? 0;
    const bWidth = b?.width ?? 0;
    if (aWidth === 0 && bWidth === 0) return true;
    if (a?.color === b?.color && a?.style === b?.style && a?.width === b?.width) return true;
    return false;
};
